import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import { useStore } from '@/store'
import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { initEmptyParam } from '@/hooks/useInitParam'
import { getBeforeDate } from '@/utils/utils'
import { Excel } from '@/utils/ExcelJs'
import { getListData } from '@/service/main/system'
import { reactive } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

var queryParam = {
  bonusOk: 1,
  dateStart: getBeforeDate('', 1),
  parentDeptId: '',
  deptName: ''
}
const store = useStore()
store.commit('system/changeQueyryInfo', queryParam)

const getParentDeptList = async () => {
  let roleData = await getListData('/main/workerPoint/queryParentDeptList', {})

  const roleItem = searchFormConfig.formItems.find(
    (item: any) => item.field === 'parentDeptId'
  )
  roleItem!.options = roleData.map((item: any) => {
    return { title: item.deptName, value: item.deptId }
  })
  roleItem!.options?.unshift({ title: '全部', value: '' })
}

getParentDeptList()

const resetCb = () => {
  return queryParam
}

const handleChange = (formData: any) => {
  store.commit('system/changeQueyryInfo', formData.value)
}

const [pageContentRef, handleResetClick, handleSearchClick] =
  usePageSearch(resetCb)

const ts2str = (ts: any) => {
  let date = new Date(parseInt(ts))
  let Year = date.getFullYear()
  let Moth =
    date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  let Day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  let Hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  let Minute =
    date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  let Second =
    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  let GMT =
    Year + '-' + Moth + '-' + Day + ' ' + Hour + ':' + Minute + ':' + Second
  return GMT
}

const getBonus = (row: any) => {
  let bonus = row.bonus || 0
  if (bonus < 300) {
    return '<span>' + bonus + '</span>'
  } else {
    return '<span style="color: #d71b1b;">' + bonus + '</span>'
  }
}

const getCallTime = (row: any) => {
  if (!row.callTime) return '-'
  return Math.round((row.callTime || 0) / 60)
}

const getExportData = async () => {
  let queryInfo = store.state.system.queryInfo
  return await getListData('/main/workerPoint/queryExportData', queryInfo)
}

const handleWorkerPoint = (item: any) => {
  getExportData().then((res) => {
    let customHeader = contentTableConfig.propList.map(
      (item: any) => item.label
    )
    let header = contentTableConfig.propList.map((item: any) => item.prop)
    let exportData: any = []
    res.forEach((item: any) => {
      item.date = item.date.substring(0, 10)
      item.callTime = getCallTime(item)
      item.callOk = item.callOk ? '是' : '否'
      exportData.push(item)
    })
    let queryInfo = store.state.system.queryInfo
    // 文件名
    let filename = ts2str(new Date().getTime()).replaceAll(/:| |-/gi, '')
    const excel = new Excel()
    excel.exportExcel({
      name: '业务员积分统计-' + queryInfo.dateStart + '-' + filename,
      title: '业务员积分统计-' + queryInfo.dateStart + '-' + filename,
      data: reactive(exportData),
      header,
      customHeader
    })
  })
}

const handleSortChange = (value: any) => {
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}


return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_PageSearch, {
      modelValue: _unref(initEmptyParam),
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick),
      onHandleChange: handleChange
    }, null, 8, ["modelValue", "searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "workerPoint",
      onDownBtnClick: handleWorkerPoint,
      onSortChange: handleSortChange
    }, {
      date: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(scope.row.date.substring(0, 10)), 1)
      ]),
      bonus: _withCtx((scope) => [
        _createElementVNode("div", {
          innerHTML: getBonus(scope.row)
        }, null, 8, _hoisted_1)
      ]),
      callTime: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(getCallTime(scope.row)), 1)
      ]),
      callOk: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(scope.row.callOk ? '是' : '否'), 1)
      ]),
      _: 1
    }, 8, ["contentTableConfig"])
  ]))
}
}

})